import React from 'react';
import { truncate, pick } from 'lodash';
import { LinkedRecordData } from '../../hooks/use-linked-records';

const styles = {
  container: {
    width: '100%',
    opacity: 1,
    transform: 'scaleY(1)',
    transformOrigin: 'top',
    transition: 'transform 0.3s ease, opacity 0.3s ease',
    position: 'relative',
    padding: 0,
    clear: 'both',
    fontSize: 13,
    borderTop: '1px solid #c9c9c9',
    backgroundColor: '#e1e1e1',
  },

  content: {
    display: 'flex',
    flexDirection: 'row',

    '@phone': {
      display: 'block',
    },
  },

  label: {
    width: '42%',
    paddingLeft: 12,
    paddingTop: 10,
    paddingBottom: 10,
    fontWeight: 'bold',

    '@phone': {
      display: 'block',
      width: '100%',
      fontWeight: 'bold',
      paddingTop: 6,
    },
  },

  data: {
    width: '42%',
    paddingLeft: 0,
    paddingTop: 10,
    paddingBottom: 10,

    '@phone': {
      display: 'block',
      width: '100%',
      fontWeight: 'bold',
      paddingTop: 6,
    },
  },

  title: {
    display: 'inline',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  spacer: {
    height: 7,
    backgroundColor: '#efefef',
    borderBottom: '1px solid #d9d9d9',
  },

  spacerExpanded: {
    height: 7,
    backgroundColor: '#efefef',
    borderTop: '1px solid #d9d9d9',
  },

  link: {
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontFamily: 'Lato, sans-serif',
    color: '#2890D4',
    padding: 0,
  },

  disabled: {
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    fontFamily: 'Lato, sans-serif',
    color: '#bbbbbb',
    padding: 0,
  },
};

interface Props extends LinkedRecordData {
  recordLabel?: string
  onView?: (linkedRecordData: LinkedRecordData) => void
  disabled?: boolean
  available: boolean
}

function LinkedRecord(props: Props) {
  const {
    formName,
    recordTitle,
    recordKey,
    recordLabel,
    disabled,
    available,
  } = props;

  const truncatedTitle = () => {
    if (recordTitle.length > 40) {
      return `${truncate(recordTitle, { length: 40 })}...`;
    }
    return recordTitle;
  };

  const handleViewClick = () => {
    const { onView } = props;

    if (onView) {
      const linkedRecordData = pick(
        props,
        ['formId', 'formName', 'recordId', 'recordTitle', 'linkedFieldKey'],
      );

      onView(linkedRecordData);
    }
  };

  const spacing = <span>&nbsp;&nbsp;&nbsp;</span>;

  const fullLink = () => (
    <>
      {recordKey}
      {recordKey && spacing}
      {/* @ts-ignore */}
      <span style={styles.title}>{truncatedTitle()}</span>
      {spacing}
      <button
        type="button"
        onClick={handleViewClick}
        style={disabled ? styles.disabled : styles.link}
        disabled={disabled}
      >
        View
        {' '}
        {recordLabel || 'record'}
      </button>
    </>
  );

  const notAvailableLink = () => (
    <button type="button" disabled>Not Available</button>
  );

  return (
    // @ts-ignore
    <div style={styles.container}>
      {/* @ts-ignore */}
      <div style={styles.content}>
        <div style={styles.label}>{formName}</div>
        <div style={styles.data}>
          { available ? fullLink() : notAvailableLink() }
        </div>
      </div>
    </div>
  );
}

export default LinkedRecord;
